import Nav from '../components/Nav';
import heroimageS from "../assets/images/small/Nadine&JP-21.webp";
import heroimageL from "../assets/images/big/Nadine&JP-21-cropped.jpg";
import image1 from "../assets/images/small/Nadine&JP-78.jpg";
import image2 from "../assets/images/small/DSCF7772_BW.jpg";
import Hero from '../components/Hero';
import {
  Box,
  Grid,
  Typography,
  Container,
} from '@mui/material'

export default function OurStory() {
  // TODO: fix padding of image1 in small view
  return (
    <Box className="our-story">
      <Nav />
      <Hero name="OUR STORY" imageS={heroimageS} imageL={heroimageL} />
      <Box className="how-they-met">
        <Container maxWidth="lg">
          <Grid
            container
            columnSpacing={{lg: 4}}
            className="paragraphs"
            justifyContent="center"
            sx={{ padding: { xs: '3em 2em 0 2em', md: '3em 2em', lg: '4em 0', xl: '7em 0' }}}
          >
            <Grid item xs={12}>
              <Typography variant="h3" align="left">How they met</Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Typography variant="body1" align="left">There could've been many chances in Manila but it just had to be in Malaysia in August of 2015. JP has just recently moved to Malaysia for a new job while Nadine also just came back from the Philippines for a short summer vacation. </Typography>
              <Typography variant="body1" align="left">With a bit of work from destiny (thanks to an app) and some stroke of serendipity, Nadine swiped right, and eventually, he did too. They talked over a week online before they decided it was time to meet each other face-to-face and the rest was history.</Typography>
              <Typography variant="body1" align="left">Time flew so fast that their first date went on in an 8-hour conversation. After dropping Nadine off at her place, JP was waiting for a cab ride home at a taxi stand near her place. Nadine looked through her window and saw him waiting by himself, so she decided to keep him company until his cab arrived. That sealed the deal for JP because he knew right there and then that she was “the one”.</Typography>
              <Typography variant="body1" align="left">Five years (Nadine’s edit: seven years, thanks COVID) and many twists and turns later, they’re ready to spend the rest of their lives together. And what better way to do it than by gathering our dearest friends and friends for one memorable day of fun and celebration.</Typography>
            </Grid>
            <Grid item xs={12} lg={6} pt={{xs: '3em', lg: '0'}}>
              <img 
                src={image1}
                className="image1"
                alt="JP and Nadine hugging"
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ pt:'15vh', pb:'8vh'}}>
        <Typography
          className="quote"
          variant="subtitle1"
          align="left"
          sx={{ width: { xs: '80%', lg: '40%' }, left: {xs: '10%', md: '3em', lg: '50%'}, padding: {xs: '0 0 3em 0', md: '0 0 3em 0', lg: '1em 0 0 0'}, position: {xs: 'relative', lg: 'absolute'}, fontSize: {xs: '32px', lg: '38px'}}}
        >
          "They were greeted with gentle greeneries and softly lit yellow hanging bulbs and were ushered to their private dining hut, which included a candle-lit dinner table surrounded by flower petals on the floor.”
        </Typography>
        <Box
          className="image2"
          src={image2}
          sx={{width: {xs: '100%', lg: '800px'}, position: {lg: 'absolute'}}}
          alt="JP and Nadine engagment"
          component="img" 
        />
      </Box>
      <Box className="the-proposal">
        <Container maxWidth="lg">
          <Grid
            container
            columnSpacing={{lg: 5}}
            className="the-proposal paragraphs"
            justifyContent="center"
            sx={{ padding: { xs: '0 2em 3em 2em', md: '0 0 8em 0', lg: '35em 0 8em 0' }}}
          >
            <Grid item xs={12}>
              <Typography className="grid-title" variant="h3" align="left">The Proposal</Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Typography variant="body1" align="left">Nadine has been staying in Manila for some time since she was waiting for her Malaysian working pass to get processed, when JP told her that he’ll be flying back home that weekend to celebrate their fifth year anniversary together. </Typography>
              <Typography variant="body1" align="left">One of Nadine’s conditions before getting married was that JP had to get her parents’ permission. He secretly did this by flying to Singapore to have “the talk” with her parents, which he thankfully survived.</Typography>
              <Typography variant="body1" align="left">Like every anniversary celebration, Nadine of course knew that she’ll be having a lovely dinner date with JP.
    After braving through the Manila traffic, they arrived at the venue, where Nadine was pleasantly surprised (Nadine’s edit: I already had an inkling, thankyouverymuch) as JP didn’t reveal that he made reservations at Ninyo Fusion Cuisine,  a lovely quaint restaurant in Quezon City. </Typography>
              <Typography variant="body1" align="left">They were greeted with gentle greeneries and softly lit yellow hanging bulbs and were ushered to their private dining hut, which included a candle-lit dinner table surrounded by flower petals on the floor. The ceiling was draped with beautiful ripples of white fabrics showering the scene a warm and romantic ambiance.</Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Typography variant="body1" align="left">Conversation over dinner only made the time fly fast. Nadine was in great spirits that night as she was confidently sharing the pinterest board details of her dream wedding  with JP over dinner. JP smiled because while she was talking passionately about her wedding wish list, she had no idea that a few tables behind them was actually JP’s best friend and sister, who were hiding to take a video and photos of JP’s big move.</Typography>
              <Typography variant="body1" align="left">The last of the six-course meal is about to be served,  when a cue of Up Dharma Down's song of Tadhana is played. The droplets of its melodic intro ensured that the restaurant steward knew the timing of how he needed to serve the colorfully designed dessert with the engagement ring beside it and the message meant for Nadine that night.</Typography>
              <Typography variant="body1" align="left">Being the sweet tooth girl that she is, Nadine's eyes were in awe (Nadine’s note: is this necessary to add?)  as the steward placed the dessert on the table with the song further placing the moment in a trance. It took her seconds to realize that JP was already on his knees, holding her hand, the diamond ring being presented in front of her. She probably couldn’t remember can't even hear the question of JP first as tears flow on her cheeks. She said yes as the ring fit perfectly on her finger and JP hugged her with happiness.</Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}